const parmSetting = [
  /** 首页 */
  {
    title: '新闻中心',
    infoType: 1,
    nc: 'I_1'
  },
  {
    title: '政策法规',
    infoType: 2,
    nc: 'I_2'
  },
  {
    title: '通知公告',
    infoType: 3,
    nc: 'I_3'
  },
  {
    title: '应急预警',
    infoType: 4,
    nc: 'I_4'
  },
  {
    title: '农技课堂',
    infoType: 5,
    nc: 'I_5'
  },
  {
    title: '科技课堂',
    infoType: 5,
    nc: 'I_5_1'
  },
  {
    title: '庄稼医生',
    infoType: 6,
    nc: 'I_6'
  },
  {
    title: '土壤墒情',
    infoType: 7,
    nc: 'I_7'
  },
  {
    title: '价格行情',
    infoType: 8,
    nc: 'I_8'
  },
  {
    title: '市场分析',
    infoType: 9,
    nc: 'I_9'
  },
  {
    title: '农业贷款',
    infoType: 10,
    nc: 'I_10'
  },
  {
    title: '农业保险',
    infoType: 11,
    nc: 'I_11'
  },
  {
    title: '地方快讯',
    infoType: 20,
    nc: 'I_20'
  },
  {
    title: '通知公告',
    infoType: 32,
    nc: 'I_32'
  },
  {
    title: '工作动态',
    infoType: 30,
    nc: 'I_30'
  },
  {
    title: '镇域介绍',
    infoType: 31,
    nc: 'I_31'
  },
  {
    title: '农资服务',
    infoType: 33,
    nc: 'I_33'
  },
  {
    title: '中心介绍',
    infoType: 40,
    nc: 'I_40'
  },
  {
    title: '村情简介',
    infoType: 41,
    nc: 'I_41'
  },
  {
    title: '重点项目',
    infoType: 42,
    nc: 'I_42'
  },
  {
    title: '新闻快讯',
    infoType: 43,
    nc: 'I_43'
  },
  {
    title: '情况简介',
    infoType: 50,
    nc: 'I_50'
  },
  {
    title: '耕种管收',
    infoType: 51,
    nc: 'I_51'
  },
  {
    title: '综合数据',
    infoType: 60,
    nc: 'I_60'
  },
  {
    title: '加工业',
    infoType: 61,
    nc: 'I_61'
  },
  {
    title: '种植大户',
    infoType: 63,
    nc: 'I_63'
  },
  {
    title: '养殖户',
    infoType: 64,
    nc: 'I_64'
  },
  {
    title: '水利设施',
    infoType: 65,
    nc: 'I_65'
  },
  {
    title: '土壤成分',
    infoType: 66,
    nc: 'I_66'
  },
  {
    title: '特色产业',
    infoType: 67,
    nc: 'I_67'
  },
  {
    title: '招商动态',
    infoType: 68,
    nc: 'I_68'
  },
  {
    title: '农业庄园',
    infoType: 70,
    nc: 'I_70'
  },
  {
    title: '产品分类',
    infoType: 71,
    nc: 'I_71'
  },
  {
    title: '成交动态',
    infoType: 73,
    nc: 'I_73'
  },
  {
    title: '旅游攻略',
    infoType: 80,
    nc: 'I_80'
  },
  {
    title: '景点介绍',
    infoType: 81,
    nc: 'I_81'
  },
  {
    title: '新闻追踪',
    infoType: 82,
    nc: 'I_82'
  },
  {
    title: '实践基地',
    infoType: 90,
    nc: 'I_90'
  },
  {
    title: '实践所',
    infoType: 91,
    nc: 'I_91'
  },
  {
    title: '供应信息',
    SdType: 1,
    CType: 1,
    nc: 'Sd_1'
  },
  {
    title: '求购信息',
    SdType: 2,
    CType: 1,
    nc: 'Sd_2'
  },
  /** 劳务的供应和求购 */
  {
    title: '劳务用工信息',
    SdType: 1,
    CType: 2,
    nc: 'Sd_3_1'
  },
  {
    title: '劳务用工信息',
    SdType: 2,
    CType: 2,
    nc: 'Sd_3_2'
  },
  /** 土地流转的供应和求购 */
  {
    title: '土地流转信息',
    SdType: 1,
    CType: 3,
    nc: 'Sd_4_1'
  },
  {
    title: '土地流转信息',
    SdType: 2,
    CType: 3,
    nc: 'Sd_4_2'
  },
  /** 农机农技的供应和求购 */
  {
    title: '农机农技信息',
    SdType: 1,
    CType: 4,
    nc: 'Sd_5_1'
  },
  {
    title: '农机农技信息',
    SdType: 2,
    CType: 4,
    nc: 'Sd_5_2'
  },
  {
    title: '其他信息',
    SdType: 1,
    CType: 5,
    nc: 'Sd_6_1'
  },
  {
    title: '其他信息',
    SdType: 2,
    CType: 5,
    nc: 'Sd_6_2'
  },
  {
    title: '经营主体',
    nc: 'BL_1_1'
  },
  {
    title: '土地全托',
    inputTitle: '标题',
    tType: 0,
    nc: 'BL_2_1'
  },
  {
    title: '土地半托',
    inputTitle: '标题',
    tType: 1,
    nc: 'BL_2_2'
  },
  {
    title: '土地流转',
    inputTitle: '片区名称',
    tType: 1,
    nc: 'BL_1'
  },
  {
    title: '专业人才',
    inputTitle: '专业专长',
    nc: 'BL_0'
  },
  /** 区域品牌 */
  {
    nc: 'BL_12_2',
    title: '品牌展示',
    inputTitle: '品牌名称'
  },
    /** 农产品品牌 */
  {
    nc: 'BL_12_3',
    title: '品牌展示',
    inputTitle: '品牌名称'
  },
  /** 明星品牌 */
{
  nc: 'BL_12_1',
  title: '品牌展示',
  inputTitle: '品牌名称'
},
/** 观光农业 */
{
  nc: 'BL_13',
  title: '观光农业',
  inputTitle: '观光园名称'
},
{
  title: '家庭农场',
  type: 3,
  nc: 'BE_3'
},
{
  title: '农民合作社',
  type: 2,
  nc: 'BE_2'
},
{
  title: '龙头企业',
  type: 1,
  nc: 'BE_1'
},
{
  title: '服务组织',
  type: 4,
  nc: 'BE_4'
}
  /** 内容页 */
]
export default parmSetting
